<template>
    <div>
        <section style="height: 100vh;display: flex;justify-content: center;">
            <!-- Payment Modal -->
            <div v-if="!isLoading" class="modal animated fadeIn show oppay" ref="paymentModalV2" data-backdrop="static">
                <div class="modal-dialog modal-dialog-centered ">

                    <button v-if="componentId != 'Status' || hideCloseButton" name="closeModal" type="button" id="close"
                        ref="close" class="close" data-dismiss="modal" @click.prevent="closeIframe"></button>

                    <div class="modal-content pb-2" :style="{ background: modalBackground }" ref="modalContent">

                        <div class="row mx-0 bg-white">
                            <div class="col-12">
                                <div class="opt-content card px-0 pt-1" :class="template === 'two' ? 'mt-0' : ''">
                                    <!-- /Payment Details -->
                                    <div class="row mx-0 px-0">
                                        <div class="details px-0 py-0 mb-2">
                                            <!-- Logo -->
                                            <div class="header">
                                                <div class="logo hacked-logo"
                                                    :style="{ 'background': `url(${client_info.merchant.logo}) !important` }">
                                                </div>

                                                <div class="client-logo">
                                                    <img :src="(app_info && app_info !== null) && app_info.logo_url ? app_info.logo_url : onepipe_favicon"
                                                        alt="">
                                                </div>
                                            </div>
                                            <!-- Logo -->

                                            <!-- Details -->
                                            <div class="text-center py-1"
                                                :style="{ background: modalBackground, color: client_info.colors.payment_description + '!important' }">

                                                <div class="amount mb-1"
                                                    :style="{ color: client_info.colors.payment_description + '!important' }">

                                                    <span style="font-size:13px;">{{ payload.transaction.currency ||
                payload.transaction.meta.currency || 'NGN' }}</span>
                                                    <span style="font-size:18px;"> {{
                amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
                                                    </span>
                                                </div>

                                                <div class="email" v-text="customer.email" style="font-size:14px;"
                                                    :class="customer && customer.email && customer.email.length > 30 ? 'small-email' : ''"
                                                    :style="{ color: client_info.colors.payment_description + '!important' || '#ffffff !important' }">
                                                </div>
                                            </div>
                                            <!-- Details -->

                                            <!-- UpsellNotice -->
                                            <div v-if="upSellNotice.length > 10" class="text-center p-2"
                                                style="background: #ff8302;color: #fff !important; -webkit-animation: blinker 0.5s linear infinite;animation: blinker 0.5s linear infinite;">
                                                <span v-html="upSellNotice" class="text-bold"></span>
                                            </div>
                                            <!-- UpsellNotice -->

                                        </div>

                                        <!--  Please choose how you would like to pay -->
                                        <div v-if="componentId === 'PaymentOptions'"
                                            class="mt-2 mx-auto px-0 text-center fade" style="width: 65%">
                                            <small style="font-weight: 600;" class="text-center">How would you like to pay?</small>
                                        </div>
                                    </div>
                                    <!-- /Payment Details -->

                                    <div class="px-4">
                                        <transition mode="out-in" name="fade">
                                            <!-- Retains Data in input boxes-->
                                            <component v-if="componentId" :is="componentId" :appColor="appColor"
                                                :data="channelDetails" :client_info="client_info" :app_info="app_info"
                                                :button_color="button_color" :channel="chosenChannel"
                                                :title_prefix="title_prefix" :template="template"
                                                @showUpsellNotice="handleUpSellNotice"
                                                @continueToMerchant="continueToMerchant" />

                                            <Spinner class="my-5" v-else :color="client_info.colors.loading_spinner">
                                                Loading ...
                                            </Spinner>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="footer text-center">
                            <span v-html="providerText"></span>
                            <div v-if="hasEnv" style="color:gold;" class="mt-2">You're in {{ env }} environment</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / Payment Modal -->
        </section>

    </div>
</template>

<script>
/* eslint-disable */
var isIframe = window.parent.location !== window.location;

var win = window.parent;
var check = window.location.hostname;

// console.log(self.location)
// console.log(top.location)

const Status = () => import('./Status.vue')
import Pin from './Pin.vue'
import OTP from './Otp.vue'
import axios from 'axios';
import CardPayment from './CardPayment.vue'
import ComingSoon from './ComingSoon.vue'
import Transfer from './Transfer.vue'
import Spinner from './includes/Spinner.vue'
import PaymentOptions from './PaymentOptions.vue';
import RedirectQuery from './RedirectQuery.vue';
import Airtime from './Airtime.vue'; // Airtime, Wallet, Bank.Account
import Redirect from './Redirect.vue'; // Masterpass, verve, visa
import {
    EventBus
} from './includes/bus.js'; // Masterpass, verve, visa


export default {
    name: 'Popup',
    components: {
        CardPayment,
        ComingSoon,
        Transfer,
        Pin,
        OTP,
        Status,
        PaymentOptions,
        Airtime,
        Redirect,
        Spinner,
        RedirectQuery
    },
    computed: {
        email() {
            var ctm = this.payload.transaction.customer;
            return ctm.email;
        },
        amount() {
            let trx = this.payload.transaction,
                amt = 0;
            if (this.$store.state.customer_processing_fee) {
                let cleanExtraCharges = this.$store.state.customer_processing_fee.toString().replace('.', '');
                amt = (parseFloat(trx.amount) + parseFloat(cleanExtraCharges)).toString().split('');
            } else {
                amt = trx.amount.toString().split('');
            }

            amt.splice(-2, 0, '.');
            return `${amt.join('')}`;
        },
    },
    watch: {
        payload(newVal) {
            this.payload = newVal;
            if (!this.$store.state.isFailed) {
                if (this.isReloadCall)
                    newVal.request_ref = this.$generateRequestRef();
                let ref = newVal.transaction.transaction_ref + '_opt';
                this.$store.dispatch('optionsTransRef', ref);
                newVal.transaction.transaction_ref = ref;
                this.paymentOptions(newVal)
            }

        },
        channels(newVal) {
            this.channels = newVal;
        },
        channelDetails(newVal) {
            this.channelDetails = newVal;
        },
        hasLoaded(newVal) {
            this.hasLoaded = newVal;
        },

    },
    destroyed() {

    },
    mounted() {

        if (check.includes('.dev.') || check.includes('localhost')) {
            this.env = 'Dev';
            this.hasEnv = true;
        } else if (check.includes('.staging.')) {
            this.env = 'Staging';
            this.hasEnv = true;
        }


        EventBus.$on('changeComponent', payload => {
            let view = payload,
                data = null;
            if (typeof payload === 'object') {
                view = payload.view
                data = payload.data
            }

            this.changeComponent(view, data)
        });
    },

    created() {

        this.source = window.location.hostname.split('.')[0].toLowerCase();
        this.isIframe = window.isIframe;

        window.addEventListener('message', (event) => {
            try {

                let payload;

                if (event.data.path == "newTransaction" && event.data.type == "inline:url") {
                    payload = this.deepClone(event.data.params);
                    this.customer = payload.transaction.customer // Customer info
                    if (Object.keys(payload.transaction).includes('options') && payload.transaction
                        .options !== null) {
                        if (Object.keys(payload.transaction).includes('template') && payload.transaction
                            .options.template !== null) {
                            this.template = payload.transaction.options.template.toLowerCase();
                        }

                        if (Object.keys(payload.transaction.options).includes('default_view') && payload
                            .transaction.options.default_view != null) {
                            if (payload.transaction.options.default_view.option && payload.transaction
                                .options.default_view.provider)
                                this.$store.dispatch('showDefaultView', true);
                        }
                    }

                    this.$store.dispatch('payload', event.data.params);
                    this.$store.dispatch('api_key', payload.api_key);
                    this.$store.dispatch('transRef', payload.transaction.transaction_ref);
                    this.$store.dispatch('parentTransRef', payload.transaction.transaction_ref);
                    this.$store.dispatch('optionsTransRef', payload.transaction.transaction_ref);
                    this.$store.dispatch('popupReferrer', payload.transaction.meta.referrer);

                    delete payload.hasTLSFallback;
                    this.payload = payload

                    // this.hasAutoClose();

                } else if (event.data.path == "replyPopupFromIframe" && event.data.type == "ui:redirect") {

                    this.hasLoaded = true;
                    let returnPayload = event.data.params;

                    // This works only for MasterPass
                    let redirectData = {
                        iframereply: {
                            message: returnPayload.message || null,
                            data: returnPayload.data,
                            provider: returnPayload.initialPayload.provider,
                            redirect_content: returnPayload.initialPayload.redirect_content
                        },

                        source: 'iframeReply',
                        channels: this.channels,
                        paymentMethod: this.channels[this.$store.state.paymentMethodIndex],
                        paymentMethodProvider: this.$store.state.paymentMethodProvider,
                        index: this.$store.state.paymentMethodIndex,
                        transaction: returnPayload.initialPayload.transaction
                    }

                    if (returnPayload.initialPayload.provider.provider.toLowerCase() !== 'mpgs') {
                        this.changeComponent("RedirectQuery", redirectData);
                    } else {
                        this.changeComponent("CardPayment", redirectData);
                    }

                } else if (event.data.path == "replyPopupFromIframe" && event.data.type == "ui:redirect-close") {
                    const paymentChannels = this.$store.state.options
                    // if the payment options 1 and it's a custom options type, just call the close callback
                    if (this.channels.length <= 1 && this.$store.state.paymentMethod == 'custom') {
                        return this.closeIframe();
                    }
                    this.tryAgainAction(false);
                } else {
                    // console.log("random event");
                }

                if (this.template === 'one') {
                    this.title_prefix = 'Pay with';
                }
            } catch (err) {
                console.log(err)
            }
        }, false);

        if (isIframe) {
            this.isIframe = true;
            this.handleTryAgainData();
        }
    },
    data() {
        return {
            componentId: '',
            channelDetails: {},
            customer: {},
            hasLoaded: false,
            isIframe: false,
            // isIframe: '',
            isCardActive: false,
            isTransferActive: false,
            isMTN: false,
            modalBackground: '',
            appColor: '',
            logoUrl: '',
            textColor: '',
            activeOption: '',
            optionsList: '',
            paymentChannels: {},
            isLoading: true,
            channels: {},
            payload: {},
            providerText: '',
            options: {},
            showStatus: false,
            env: "",
            hasEnv: false,
            isReloadCall: false,
            chosenChannel: "",
            client_info: {},
            app_info: {},
            button_color: {},
            idleTimeOut: '',
            template: 'default',
            title_prefix: '',
            upSellNotice: "",
            hideCloseButton: false,
            onepipe_favicon: 'https://cdn.onepipe.io/assets/favicon/onepipe/favicon-32x32.png',
        }
    },
    methods: {

        handleUpSellNotice(msg) {
            this.upSellNotice = msg;
        },

        handleTryAgainData() {
            // Check to see if values are still presenttryAgainAction
            if (this.$store.state.payload && this.$store.state.isFailed) { // Try Again Button here

                this.$store.dispatch('transRef', this.$generateTransactionRef());
                const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
                this.$store.dispatch('transRef', newRef);
                this.customer = this.$store.state.payload.transaction.customer // Customer info

                let payload = this.$store.state.payload;
                if (Object.keys(payload.transaction).includes('options') && payload.transaction.options != null) {
                    if (Object.keys(payload.transaction.options).includes('template') && payload.transaction.options
                        .template != null)
                        this.template = payload.transaction.options.template.toLowerCase();
                }

                this.tryAgainAction(true);
            } else if (this.payload.api_key != undefined && !this.$store.state.isFailed) {
                let payload = this.payload;
                if (Object.keys(payload.transaction).includes('options') && payload.transaction.options != null) {
                    if (Object.keys(payload.transaction.options).includes('template') && payload.transaction.options
                        .template != null)
                        this.template = payload.transaction.options.template.toLowerCase();
                }

                this.paymentOptions(this.payload);
            }
        },

        idleCheck() {
            if (this.hasLoaded) {
                this.idleTimeOut = setTimeout(() => {
                    console.log("Idle timeout monitoring started");
                    this.timeout();
                }, 3000);

                let vm = this;

                window.addEventListener("click", () => {
                    console.log("One click just occured, timeout increased for another 10 seconds");
                    if (this.idleTimeOut > 0) {
                        console.log("remove old timeout id" + this.idleTimeOut)
                        clearInterval(this.idleTimeOut);
                    }

                    this.idleTimeOut = setTimeout(() => {
                        console.log("New idle timeout monitoring started");
                        vm.timeout();
                    }, 10000);

                    console.log("New/Update timeout id" + this.idleTimeOut)
                });

            } else {

                console.log("Waiting for popup to be triggered");

            }
        },

        timeout() {
            // console.log("You session has expired");
            if (this.idleTimeOut > 0) {
                clearInterval(this.idleTimeOut);
                console.log(this.idleTimeOut);
                this.$router.replace('/v2/timeout');
            }
        },

        tryAgainAction(status = true) {
            try {

                if (!status) {
                    this.$store.dispatch('transRef', this.$generateTransactionRef());
                    const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
                    this.$store.dispatch('transRef', newRef);
                }

                this.channels = this.paymentChannels = this.$store.state.options
                this.channels = this.channelDetails.channels = this.$store.state.options;

                let client_info = null
                client_info = this.client_info = this.$store.state.client_info;
                this.app_info = this.$store.state.app_info;
                this.button_color = {
                    background: client_info.colors.primary_button || client_info.colors.app,
                    color: client_info.colors.payment_description ? client_info.colors.payment_description +
                        '!important' : ''
                }

                this.providerText = client_info.footer_text;
                this.modalBackground = client_info.colors.modal_background + ' !important';
                this.appColor = client_info.colors.primary_button + ' !important';

                if (status) {
                    this.payload = this.$store.state.payload
                }

                this.isLoading = false;
                this.channelDetails.channels = this.paymentChannels
                this.changeComponent("PaymentOptions")
            } catch (err) {
                console.log(err)
            }
        },

        reload() {
            this.componentId = "";
            this.hasLoaded = false;

            let initialPayload = this.$store.state.payload,
                payload = this.deepClone(initialPayload);

            let ref = this.$generateTransactionRef();
            this.$store.dispatch('optionsTransRef', ref);
            payload.request_ref = ref + '_opt_rt';
            payload.transaction.transaction_ref = ref;
            this.isReloadCall = true;
            this.paymentOptions(payload);
        },

        getInitialPayload() {
            let p = this.$store.state.payload
            delete p.hasTLSFallback
            delete p.referrer
            delete p.mode

            return p;
        },

        paymentOptions(payload) {
            let data2 = {
                endpoint: 'options',
                api_key: this.$store.state.api_key,
                payload,
            }

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data: this.$generateToken(data2)
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(({ data }) => {

                try {

                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    window.raw = JSON.stringify(res);

                    if (!["successful", "processing", "optionsdelivered"].includes(status)) {
                        window.failedFromStartMessage = message ||
                            "An error occured from the main server, please try again or contact the webmaster hussien@onepipe.io.";
                        window.failedFromStart = true;
                        this.$router.push('/v2/warning');
                        return
                    }

                    let payloadTransaction = this.$store.state.payload.transaction
                    if (payloadTransaction.options != null && Object.keys(payloadTransaction.options).includes("payment_options")) {
                        responseData.options = this.preferredPaymentOptions(payloadTransaction
                            .options.payment_options,
                            responseData.options);
                    }

                    // Remove other options and append it as last item
                    let otherOptions = responseData.options.find((x) => ['other options', 'other payment options'].includes(x.title.toLowerCase()));

                    // Append Other Options as always the last item.
                    responseData.options = responseData.options.filter((x) => !(['other options', 'other payment options', 'other'].includes(x.title.toLowerCase())));

                    if (otherOptions !== undefined) {
                        responseData.options.push(otherOptions);
                    }

                    this.hasLoaded = true;
                    this.channels = this.paymentChannels = responseData.options;
                    this.channelDetails.channels = this.paymentChannels

                    this.$store.dispatch('options', responseData.options);
                    this.$store.dispatch('channels', this.paymentChannels);
                    this.$store.dispatch('client_info', responseData.client_info);
                    this.$store.dispatch('app_info', responseData.app_info);

                    this.client_info = responseData.client_info;
                    let client_info = responseData.client_info;
                    this.app_info = responseData.app_info;

                    this.button_color = {
                        background: client_info.colors.primary_button || client_info.colors.app,
                        color: client_info.colors.payment_description ? client_info.colors
                            .payment_description +
                            '!important' : ''
                    }

                    this.providerText = responseData.client_info.footer_text;
                    this.modalBackground = responseData.client_info.colors.modal_background +
                        ' !important';
                    this.appColor = responseData.client_info.colors.primary_button + ' !important';
                    this.logo = responseData.client_info.image_url;

                    this.isLoading = false;
                    this.componentId = "PaymentOptions";

                    //  Begin tracking idle moments
                    // this.idleCheck();

                } catch (err) {
                    console.log(err);
                    window.failedFromStart = true;
                    window.failedFromStartMessage = err
                    window.raw = JSON.stringify(err);
                    this.$router.push('/v2/warning');
                }
            }).catch(error => {
                console.log(error);
                window.failedFromStart = true;
                window.failedFromStartMessage = error
                window.raw = JSON.stringify(error);
                this.$router.push('/v2/warning');
            });

        },

        changeComponent(name, data = null) {
            if (this.componentId == 'Status')
                return;
            this.componentId = name;
            if (data != null)
                this.channelDetails.details = data;
        },

        updateComponent(key) {
            if (this.componentId == 'Status')
                return;
            this.channelDetails.details = this.channels[key]

            this.$store.dispatch('paymentMethod', this.channelDetails.option)
            this.selectComponent(this.channels[key].auth_type, key)
        },

        selectComponent(method, index) {
            let data = this.channels[index];

            let componentId = "",
                activeName = "";

            switch (method.toLowerCase()) {
                case "airtime":
                    componentId = "Airtime";
                    activeName = "Airtime";
                    break;

                case "wallet":
                    componentId = "Airtime";
                    activeName = "wallet";
                    break;

                case "bank.account":
                    componentId = "Airtime";
                    activeName = "account";
                    break;

                case "voucher":
                    componentId = "Voucher";
                    activeName = "voucher";
                    break;

                case "bank.transfer":
                    componentId = "Transfer";
                    activeName = "Transfer";
                    break;

                case "cash":
                    this.componentId = "Transfer";
                    activeName = "cash";
                    break;

                case "masterpass":
                case "ipg":
                    componentId = "Redirect";
                    break;

                default:
                case "card":
                    componentId = "CardPayment";
            }

            this.changeComponent(componentId, data);
        },

        deepClone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },

        closeIframe() {
            this.js_upsell_notice = ''
            this.isLoading = true;
            this.hasLoaded = false;
            this.componentId = 'PaymentOptions';
            let referrer = this.$store.state.popupReferrer

            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                payload: {},
                service_call_payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                },
                customer_processing_fee: 0.00,
            });

            this.$store.dispatch('isFailed', false);

            if (isIframe) {
                window.parent.postMessage('close', referrer.includes("file://") ? "*" : referrer);

                if (this.$route.name !== 'popup-v2')
                    this.$router.push('/v2/popup').catch(err => { });

                // this.$destroy();
                this.componentId = '';
            } else
                console.warn("Oops.. Payment Popup can only close when triggered from an iframe");

        },

        continueToMerchant(data) {

            this.js_upsell_notice = ''
            var raw = JSON.parse(window.raw)
            delete raw.data.client_info ? raw.data.client_info : raw.client_info;
            delete raw.data.paymentoptions ? raw.data.paymentoptions : raw.paymentoptions;

            var dataResponse = data.data || raw.data

            delete dataResponse.client_info;
            delete data.client_info;

            let referrer = this.$store.state.popupReferrer,
                response = {
                    status: data.status,
                    message: data.message,
                    data: dataResponse,
                    amount: this.$store.state.payload.transaction.amount || 0,
                    paymentmethod: this.$store.state.paymentMethod || null,
                    reference: this.$store.state.transRef || null,
                    optionsTransRef: this.$store.state.optionsTransRef || null,
                }

            if (this.$store.state.isFailed)
                response.parentTransRef = this.$store.state.parentTransRef

            this.$store.replaceState({
                paymentMethod: '',
                paymentMethodIndex: '',
                client_info: {},
                payload: {},
                service_call_payload: {},
                options: {},
                api_key: null,
                isFailed: false,
                hasPaid: false,
                hasOtp: false,
                isLoading: true,
                channels: {},
                popupReferrer: null,
                provider: {},
                card_cc: '',
                card_exp: '',
                card_cvv: '',
                parentTransRef: '',
                optionsTransRef: '',
                showDefaultView: false,
                transRef: '',
                cardDetails: {
                    card_cc: '',
                    card_exp: '',
                    card_cvv: '',
                    card_pin: '',
                },
                customer_processing_fee: 0.00,
            });

            if (this.$route.name !== 'popup-v2') {
                this.$router.push('/v2/popup').catch(err => { });
            }

            window.parent.postMessage(JSON.stringify(response), referrer.includes("file://") ? "*" : referrer);
            // this.componentId = '';

            // delete the cache response
            this.componentId = null;
            delete window.raw;
        },

        hasAutoClose(auth_type, status) {

            try {

                let initialPayload = this.getInitialPayload();
                if (Object.keys(initialPayload.transaction).includes('options') && initialPayload.transaction
                    .options != null) {
                    let options = initialPayload.transaction.options;
                    if (Object.keys(options).length > 0 && Object.keys(options).includes('close_popup')) {
                        let close_popup = initialPayload.transaction.options.close_popup,
                            timeout = close_popup.timeout || 3, // 3 seconds by default
                            statuses = close_popup.status, // Pick status from initial payload
                            statusArray = [];

                        if (statuses != "undefined" && timeout != "undefined") {
                            switch (status.toLowerCase()) {
                                case "successful":
                                case "success":
                                    // statusArray = statuses.Successful
                                    statusArray = statuses.Successful
                                    break;

                                case "failed":
                                    statusArray = statuses.Failed
                                    break;

                                case "pendingfulfillment":
                                    statusArray = statuses.PendingFulfillment
                                    break;

                                case "optionsdelivered":
                                    statusArray = statuses.OptionsDelivered
                                    break;
                            }

                            // Check if auth_type is present in statusArray
                            // console.log(statusArray);
                            if (statusArray !== "undefined") {
                                if (statusArray.length > 0 && statusArray.indexOf(auth_type) > -1)
                                    return {
                                        status: true,
                                        timeout
                                    }; // return timeout along side too
                                else // It's not present
                                    return {
                                        status: false,
                                        timeout: 0,
                                    }
                            } else { // UNable to pick a status match
                                return {
                                    status: false,
                                    timeout: 0,
                                }
                            }
                        } else { // Status was not set from initial paylaod
                            return {
                                status: false,
                                timeout: 0,
                            }
                        }
                    } else // "No Close Popup in options
                        return {
                            status: false,
                            timeout: 0,
                        }
                } else // Options is present
                    return {
                        status: false,
                        timeout: 0,
                    }
            } catch (err) {
                console.log(err)
            }
        },

        hasDefaultView() {

            try {

                let initialPayload = this.getInitialPayload();

                if (initialPayload.transaction.options == null) {
                    return {
                        status: false,
                    }
                }

                if (Object.keys(initialPayload.transaction.options).includes('default_view')) {
                    let default_view = initialPayload.transaction.options.default_view,
                        option = default_view.option.toLowerCase(),
                        provider = default_view.provider.toLowerCase();

                    if (this.paymentChannels == null) {
                        return {
                            status: false,
                        };
                    }

                    let isExist = this.paymentChannels.find((item, index) => {

                        // Check if specified auth_type is present in the Options Response, now check when Options returns multiple auth types
                        if (item !== undefined && option === item.auth_type.toLowerCase()) {

                            item['key'] = index;

                            if (item.action.length > 0) { // check if specified provider is present in the list of providers for this auth type.

                                let providerIsPresent = item.action.filter((opt, key) => {
                                    if (opt.provider.toLowerCase() == provider) {
                                        item['provider_key'] = `${key}`;
                                        return opt;
                                    }
                                });

                                if (providerIsPresent.length > 0) {
                                    let reCheck = providerIsPresent[0];
                                    if (reCheck.provider.toLowerCase() == provider) {
                                        return item;
                                    } else {
                                        window.failedFromStart = true;
                                        window.failedFromDefaultView = true;
                                        let raw = JSON.parse(window.raw);
                                        raw.message = `${provider} provider is not present in the payment option.`;
                                        window.raw = JSON.stringify(raw);
                                        this.$router.push('/v2/warning').catch(() => { });
                                        return;
                                    }
                                }
                            } else {
                                window.failedFromStart = true;
                                window.failedFromDefaultView = true;
                                let raw = JSON.parse(window.raw);
                                raw.message =
                                    "The default provider you set is not available/enabled. Please contact your admin.";
                                window.raw = JSON.stringify(raw);
                                this.$router.push('/v2/warning').catch(() => { });
                                return;
                            }
                        }
                    });

                    if (isExist) {
                        this.$store.dispatch('showDefaultView', false);
                        return {
                            status: true,
                            auth_type: isExist.auth_type,
                            key: isExist.key,
                            provider_key: isExist.provider_key,
                        };
                    }
                }

            } catch (err) {
                console.log(err)
            }
        },

        preferredPaymentOptions(payment_options, default_options) {
            // console.log(default_options);
            try {
                const dt = default_options.filter((item, index) => {
                    let prefferedOptionsKey = Object.keys(payment_options);

                    /**
                     ** Get the Preferred options key
                     ** Filter the options sent from the server against the preferred option
                     ** Filter the providers for each options again the preffered option of the current array index
                     **/

                    if (item !== undefined && prefferedOptionsKey.includes(item.auth_type.toLowerCase())) { // Filter the payment options Eg card, custom,
                        if (item.action && item.auth_type.toLowerCase() != "card") { // Skip this for Card payment options such as card, mpgs
                            let keyIndex = prefferedOptionsKey.indexOf(item.auth_type.toLowerCase()); // Get array index of current auth type
                            let keyIndexProviderArray = Object.values(payment_options)[keyIndex].map(y => y.toLowerCase()); // Get provider array using the auth_type key index
                            item.action = item.action.filter((elem, idx) => elem.provider && (keyIndexProviderArray.includes(elem.provider.toLowerCase()) || elem.provider.toLowerCase() == "comingsoon"));
                        } else { // Only Card, mpgs options

                        }

                        return item;

                    }
                }).filter((x) => x !== undefined && x.auth_type.toLowerCase() === 'card' || ((x.action && x
                    .action !== null) && x.action.length > 0));
                return dt;
            } catch (err) {
                console.log("[Preferred Payment Options Error]:" + err);
            }
        },

    },

};
</script>

<style scoped>
.bg-white {
    background: #fff !important;
}

.header {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
}

.provider-logo,
.client-logo img {
    width: auto !important;
    height: auto !important;
    max-width: 35px !important;
    max-height: 35px !important;
    display: inline-block !important;
}

.hacked-logo {
    /* width: 32px !important;
    height: 32px !important; */
    width: 35px !important;
    height: 35px !important;
    background-repeat: no-repeat !important;
    /* border: solid #ffffff 1.3px; */
    /*border: solid #ffffff 2px;*/
    border: solid #ffffff00 2px;

}

.circular-logo-holder {
    text-align: center;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background: #fff;
    margin-left: auto !important;
    margin-right: auto !important;
}

.circular-logo-holder .hacked-logo {
    border: none !important;
    width: 30px !important;
    height: 30px !important;
    margin-top: 11px !important;
}

.nshaped-logo-holder {
    text-align: center;
    height: 45px;
    width: 55px;
    border-radius: 50% 50% 5% 0%;
    background: #fff;
    margin-left: auto !important;
    margin-right: auto !important;
}

.nshaped-logo-holder .hacked-logo {
    border: none !important;
    width: 30px !important;
    height: 30px !important;
    margin-top: 10px;
}

.fg-1 {
    flex-grow: 1;
}

.fg-2 {
    flex-grow: 2;
}

.nav-hack {
    display: flex;
    align-items: justify;
    flex-wrap: wrap;
}

ul.nav-hack li {
    flex: 2 -1 auto;
    align-self: center;
    color: #ffffff;
}

ul.nav-hack li a {
    border-radius: 20px !important;
    background: #7d7171 !important;
    margin-bottom: 5px;
}

ul.nav-hack li a:hover,
ul.nav-hack li a:focus {
    border-radius: 20px !important;
    background: rgb(128, 69, 147) !important;
    border: 1px solid #7d7171;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .1s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    transition: opacity .25s ease-in-out;
    -moz-transition: opacity .25s ease-in-out;
    -webkit-transition: opacity .25s ease-in-out;
    opacity: 0;
}

.disabled,
a.disabled {
    text-decoration: none;
    cursor: not-allowed;
}

.small-email {
    font-size: 12.5px !important;
}
</style>
